<template>
    <div class="vue-product-carousel">
        <div class="row mb-3">
            <div class="col-12">
                <div class="thumbnail-wrapper">
                    <button @click="handlePrevious" class="arrow-button button-left"><span class="chevron-left"></span></button>

                    <div class="product-thumbnail-wrapper" @click="lightboxIndex = currentIndex">
                        <img :src="thumbnail" class="img-fluid product-thumbnail">
                    </div>

                    <button @click="handleNext" class="arrow-button button-right"><span class="chevron-right"></span></button>
                </div>
            </div>
        </div>

        <template v-if="hasSlides === true">
            <hooper ref="carousel" :settings="hooperSettings" @slide="handleSlide">
                <slide v-for="(image, index) in images" :key="index">
                    <a href="#" @click.prevent="handleSlideClick(index)">
                        <img :src="image">
                    </a>
                </slide>
            </hooper>

        </template>

        <vue-gallery-slideshow :images="images" :index="lightboxIndex" @close="lightboxIndex = null"></vue-gallery-slideshow>
    </div>
</template>

<script>
import {Hooper, Slide, Navigation as HooperNavigation} from 'hooper';
import 'hooper/dist/hooper.css';

import VueGallerySlideshow from 'vue-gallery-slideshow';

export default {
    name: "productCarousel",

    props: ['images'],

    components: {
        Hooper,
        Slide,
        HooperNavigation,
        VueGallerySlideshow
    },

    data() {
        return {
            thumbnail: null,

            hooperSettings: {
                itemsToShow: 3,
                wheelControl: false,
                breakpoints: {
                    1024: {
                        itemsToShow: 4
                    }
                }
            },

            lightboxIndex: null,
            currentIndex: 0
        }
    },

    mounted() {
        this.thumbnail = this.images[0];
    },

    computed: {
        hasSlides() {
            return !_.isEmpty(this.images) && this.images.length >= 2;
        },

        filteredSlides() {
            return _.filter(this.images, (slide) => {
                return ! lodash.isNil(slide);
            })
        },

        lastSlide() {
            return this.filteredSlides.length - 1;
        },

        previousSlide() {
            if (_.isEqual(this.currentIndex, 0)) {
                return this.lastSlide;
            }

            return this.currentIndex - 1
        },

        nextSlide() {
            if (_.isEqual(this.currentIndex, this.lastSlide)) {
                return 0;
            }

            return this.currentIndex + 1
        },
    },

    methods: {
        handleSlide(payload) {
            if (this.hasSlides === false) {
                return;
            }

            this.thumbnail = this.images[payload.currentSlide];
            this.currentIndex = payload.currentSlide;
        },

        handleSlideClick(index) {
            this.$refs.carousel.slideTo(index);
        },

        handlePrevious() {
            this.thumbnail = this.images[this.previousSlide];
            this.currentIndex = this.previousSlide;

            this.handleSlideClick(this.currentIndex);
        },

        handleNext() {
            this.thumbnail = this.images[this.nextSlide];
            this.currentIndex = this.nextSlide;

            this.handleSlideClick(this.currentIndex);
        }
    }
}
</script>
